// frontend/src/core/api/client.js
//
// Transport only. Knows nothing about endpoints, resources, or regions.
// This is the only file in src/ (besides health.js) that calls fetch() directly.
// Never put secrets in VITE_* — everything here ships in the public bundle.

export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

if (import.meta.env.PROD && !API_BASE_URL) {
  console.error(
    '[api] VITE_API_URL is not set in a production build. ' +
    'Requests will hit the deployment origin.'
  );
}

export class ApiError extends Error {
  constructor(message, { status = 0, body = null } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

const readJsonResponse = async (res) => {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return {};
  }
};

export const apiFetch = async (path, { token, ...init } = {}) => {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers || {}),
    },
  });

  const body = await readJsonResponse(res);

  if (!res.ok) {
    throw new ApiError(
      body?.error || `Request failed (${res.status})`,
      { status: res.status, body }
    );
  }

  return body;
};